<script lang="ts">
  type Icon = 'today' | 'calendar' | 'dashboard' | 'contacts' | 'scheduled' | 'teach' | 'settings';
  let { icon, label, active = false, onNavigate }:
    { icon: Icon; label: string; active?: boolean; onNavigate: () => void } = $props();
  function onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onNavigate();
    }
  }
</script>

<div class="sidebar-item" class:active role="button" tabindex="0" aria-label={label} title={label}
  onclick={onNavigate} onkeydown={onKeydown}>
  {#if icon === 'teach'}
    <span class="nav-glyph teach-spark">✦</span>
  {:else}
    <span class="nav-glyph"><svg viewBox="0 0 24 24">
      {#if icon === 'today'}
        <path d="M13 2 3 14h9l-1 8 10-12h-9l1-8Z"/>
      {:else if icon === 'calendar'}
        <rect x="3" y="4" width="18" height="17" rx="2"/><path d="M3 9h18M8 2v4M16 2v4"/>
      {:else if icon === 'dashboard'}
        <rect x="3" y="3" width="7" height="9" rx="1"/><rect x="14" y="3" width="7" height="5" rx="1"/><rect x="14" y="12" width="7" height="9" rx="1"/><rect x="3" y="16" width="7" height="5" rx="1"/>
      {:else if icon === 'contacts'}
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      {:else if icon === 'scheduled'}
        <circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>
      {:else}
        <circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
      {/if}
    </svg></span>
  {/if}
  {label}
</div>
